import GoogleMapsLoader from 'google-maps';

GoogleMapsLoader.KEY = 'AIzaSyDlGgTNgTUzZnTbOkmPiJE9hlmSB9gkBVc';
GoogleMapsLoader.LIBRARIES = ['geometry', 'places'];

export default GoogleMapsLoader;
